import { render, staticRenderFns } from "./xszm.vue?vue&type=template&id=636a13ac"
import script from "./xszm.vue?vue&type=script&lang=js"
export * from "./xszm.vue?vue&type=script&lang=js"
import style0 from "./xszm.vue?vue&type=style&index=0&id=636a13ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports